import { InMemoryCache } from 'apollo-cache-inmemory';

export default () => {
  const cache = new InMemoryCache();
  return {
    httpEndpoint: process.env.GRAPHQL_URL,
    cache,
  };
};
